













































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DocumentCollection from '@/profile/your-documents/components/document-collection.component.vue';
import UploadModal from '@/profile/your-documents/components/upload-modal.component.vue';
import YourDocumentsService from '@/profile/your-documents/services/your-documents.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import Document from '@/profile/your-documents/entities/document.entity';
import DocumentType from '@/profile/your-documents/entities/document-type.entity';
import LogService from '@/_shared/services/log/log.service';
import DocumentMetadata from '@/profile/your-documents/entities/document-metadata.entity';

@Component({
  components: {
    DocumentCollection,
    UploadModal,
  },
})
export default class YourDocumentsView extends Vue {
  private hasFinishedLoading = false;
  private documentTypes: DocumentType[] | null = null;
  private documents: Document[] | null = null;

  $refs!: {
    uploadModal: UploadModal;
    downloadComponent: HTMLFormElement;
  }

  get showPrivacyPolicyUrl(): boolean {
    try {
      // eslint-disable-next-line no-new
      new URL(this.privacyPolicyUrl);
    } catch (e) {
      return false;
    }

    return true;
  }

  get privacyPolicyUrl(): string {
    return this.$t('PROFILE.YOUR_DOCUMENTS.LINK_URL').toString();
  }

  get rep(): Rep {
    return this.$store.state.RepStore.rep;
  }

  get showCollection(): boolean {
    if (!this.documents) return false;
    return this.documents?.length > 0;
  }

  private async created(): Promise<void> {
    await this.$store.dispatch('showLoading');
    await this.retrieveDocumentTypes();
    await this.retrieveRepFiles();

    this.$emit('done-loading');
    await this.$store.dispatch('hideLoading');
    this.hasFinishedLoading = true;
  }

  private retrieveDocumentTypes() {
    return YourDocumentsService.retrieveDocumentTypes()
      .then((documentTypes) => {
        this.documentTypes = documentTypes;
      });
  }

  private retrieveRepFiles() {
    return YourDocumentsService.retrieveRepFiles()
      .then((documents) => {
        this.documents = documents;
      });
  }

  private async downloadDocument(document: Document): Promise<void> {
    await this.$store.dispatch('showLoading');
    const metadata = await YourDocumentsService.retrieveDownloadMetadata(document);

    if (this.isSafariBrowser()) {
      this.openFile(metadata.path);
    } else {
      this.downloadWithRef(metadata);
    }

    await this.$store.dispatch('hideLoading');
  }

  private openFile(filePath: string): void {
    if (!window.open(filePath, '_blank')) {
      window.location.href = filePath;
    }
  }

  private downloadWithRef(metadata: DocumentMetadata): void {
    this.$refs.downloadComponent.href = metadata.path;
    this.$refs.downloadComponent.download = metadata.name;
    this.$refs.downloadComponent.click();
  }

  private isSafariBrowser(): boolean {
    return (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent));
  }

  private openUploadModal(): void {
    this.$refs.uploadModal.show();
  }

  private closeUploadModal(): void {
    this.$refs.uploadModal.hide();
  }

  private async uploadDocument(document: Document, file: File): Promise<void> {
    await this.$store.dispatch('showLoading');
    try {
      YourDocumentsService.validateFile(document, file);
      const metadata = await YourDocumentsService.generateUploadMetadata(document);
      await YourDocumentsService.uploadDocument(metadata, file);
      await YourDocumentsService.activateDocumentVersion(metadata);

      LogService.toastrSuccess(
        this.$t('PROFILE.YOUR_DOCUMENTS.UPLOAD_SUCCESS').toString(),
        this.$t('PROFILE.TOAST_SUCCESS_HEADER').toString(),
      );

      await this.retrieveRepFiles();
      this.closeUploadModal();
    } catch (error) {
      LogService.toastrError(
        this.$t(error.message).toString(),
        this.$t('PROFILE.TOAST_ERROR_HEADER').toString(),
      );
    } finally {
      await this.$store.dispatch('hideLoading');
    }
  }
}
